export const parseError = (error, t) => {
  if (error && error.message) {
    return t('COMMON.ERROR', {
      message: error.message,
    });
  }
  return t('TASK_LIST.UNKOWN_ERROR');
};
